import { sendNewRelicEvent } from "../utils/newRelicEvents";
import * as api from "./apis/authenticateMfa";
import { emit, triggerError } from "../utils/eventManager";
import { setTokens } from "./setTokens";
export { authenticateMfa };
async function authenticateMfa(params, deviceId) {
  try {
    sendNewRelicEvent({
      EventName: 'authenticateMfa_start'
    });
    var tokens = await api.authenticateMfa(params, deviceId);
    var idToken = tokens.idToken,
      accessToken = tokens.accessToken;
    sendNewRelicEvent({
      EventName: 'authenticateMfa_success'
    });
    emit('login.success', tokens);
    await setTokens({
      idToken: idToken,
      accessToken: accessToken,
      callInitSession: true,
      broadcast: true
    });
    return tokens;
  } catch (e) {
    var err = e;
    sendNewRelicEvent({
      EventName: 'authenticateMfa_failed',
      criticalError: err.criticalError,
      error_code: err.code,
      description: err.description
    });
    triggerError('mfa', e);
    throw e;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/one-auth-sdk/dist/esm/methods/authenticateMfa.js
// module id = 5495
// module chunks = 11